import { AnyAction } from "redux";

import { GetCustomersList, GetUsersList, UpdateManageSearchParams, GetCustomer, UpdateCustomerField, GetUser, UpdateUserField, ResetManageUser, UpdateCountryList } from '../actions/actionTypes';
import { updateObject } from '../../services/utilService';

import { SortingType, UserTypes, UserColumns } from '../../shared/models/adminModels';
import update from "react-addons-update";

const initialState = {
  userList: {
    recordsTotal: 0,
    currentPage: 1,
    pageSize: 10,
    orderBy: '',
    sortType: SortingType.NULL,
    data: [],
    totalPages: 1,
    searchParameter: ''
  },
  customerList: {
    recordsTotal: 0,
    currentPage: 1,
    pageSize: 10,
    orderBy: '',
    sortType: SortingType.NULL,
    data: [],
    totalPages: 1,
    searchParameter: ''
  },
  customer: {},
  user: {},
  countryList: []
};

const getUsersList = (state: any, action: any) => {
  const { recordsTotal, pageSize } = action.payload;

  return updateObject(state, {
    userList: {
      ...state.userList,
      ...action.payload,
      totalPages: recordsTotal ? Math.ceil(recordsTotal / pageSize) : 1
    }
  });
}

const getCustomersList = (state: any, action: any) => {
  const { recordsTotal, pageSize } = action.payload;

  return updateObject(state, {
    customerList: {
      ...state.customerList,
      ...action.payload,
      totalPages: recordsTotal ? Math.ceil(recordsTotal / pageSize) : 1
    }
  });
}

const getCustomer = (state: any, action: any) => {
  return updateObject(state, {
    customer: action.payload
  });
}

const getUser = (state: any, action: any) => {
  return updateObject(state, {
    user: action.payload
  });
}

const updateCustomerField = (state: any, action: any) => {
  const { field, value } = action.payload
  return update(state, {
    customer: {
      [field]: { $set: value }
    }
  });
}

const updateUserField = (state: any, action: any) => {
  const { field, value } = action.payload
  return update(state, {
    user: {
      [field]: { $set: value }
    }
  });
}

const updateManageSearchParams = (state: any, action: any) => {
  const { params, userType } = action.payload;

  return userType === UserTypes.USER
    ? updateObject(state, {
      userList: {
        ...state.userList,
        ...params
      }
    })
    : updateObject(state, {
      customerList: {
        ...state.customerList,
        ...params
      }
    });
}

const resetToInitialState = (state: any) => {
  return updateObject(state, initialState);
}

const updateCountryList = (state: any, payload: any) => {
  return updateObject(state, {
    countryList: payload
  })
}

const managementReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case GetCustomersList: return getCustomersList(state, action);
    case GetUsersList: return getUsersList(state, action);
    case GetCustomer: return getCustomer(state, action);
    case UpdateCustomerField: return updateCustomerField(state, action);
    case GetUser: return getUser(state, action);
    case UpdateUserField: return updateUserField(state, action);
    case UpdateManageSearchParams: return updateManageSearchParams(state, action);
    case ResetManageUser: return resetToInitialState(state);
    case UpdateCountryList: return updateCountryList(state, action.payload);
    default: return state;
  }
}

export default managementReducer;